module.exports = __webpack_public_path__ + "img/10n.8aa99457.png";